module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cross-red-4e1f02927330342566bf628d11abc13a.svg";